import React from 'react'
import { Helmet } from 'react-helmet-async'
import RegisterForm from '../components/register/RegisterForm'

export default function Register() {
  return (
    <>
      <Helmet>
        <title>Register - A Plus A Driving School</title>
        <meta name="description" content="Register for driving lessons at A Plus A Driving School. Choose from our comprehensive programs for teens and adults." />
      </Helmet>
      <div className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <div className="text-accent font-heading font-semibold text-sm uppercase tracking-wider mb-2">
                Get Started
              </div>
              <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-4">
                Register for Driving Lessons
              </h1>
              <p className="text-lg text-secondary-text">
                Fill out the form below to enroll in one of our comprehensive driving programs.
              </p>
            </div>
            <RegisterForm />
          </div>
        </div>
      </div>
    </>
  )
}

